import { Level } from './LevelPageUnit';

export class LevelsPageLevel {
  thumbSrc: string;
  type: string;
  status: string;
  position: number;
  title: string;
}

export type LevelCardStatus = 'current' | 'done' | 'blocked';

export const getLevelCardStatus = (level: Level, currentLevel: number): LevelCardStatus => {
  if (level.status === 'pending' && level.position > currentLevel) {
    return 'blocked';
  }
  if (level.status === 'in_progress') {
    return 'current';
  }
  return 'done';
};

export const getLevelCardButtonText = (level: Level, cardStatus: string, t: any) => {
  if (cardStatus === 'current') {
    return t('continue');
  }
  if (cardStatus === 'done') {
    return t('select');
  }
  return null;
};
